import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import api from '../../api/manage_database/FlowMeterReq';
import SelectThoroughfare from "../../components/SelectThroughfare";
import SelectPlace from "../../components/SelectPlace";
import SelectTypeLines from "../../components/SelectTypeLines";
import BackButton from "../../components/BackButton";
import { toast } from 'sonner';


const FlowMeterChoice = () => {

    const [flowMeters, setFlowMeters] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [places, setPlaces] = useState([]);
    const [selectedThoroughfare, setSelectedThoroughfare] = useState('');
    const [thoroughfares, setThoroughfares] = useState([]);
    const [selectedTypeLine, setSelectedTypeLine] = useState('');
    const [typeLines, setTypeLines] = useState([]);

    const navigate = useNavigate();

    const handleView = () => {
        if (flowMeters.length === 0) {
            toast.error('There is no available flow meters!')
            return
        }
        const filteredFlowMeterId = flowMeters
            .filter(
                flowmeter => flowmeter.location_id.place === selectedPlace &&
                flowmeter.location_id.thoroughfare === selectedThoroughfare && 
                flowmeter.location_id.type_line === selectedTypeLine)
            .map((flowmeter) => (flowmeter.id))[0]
            navigate(`../record/${filteredFlowMeterId}`)
        }

    useEffect(() => {
        const fetchFlowMeters = async () => {
            try {
                const response = await api.get('all', {withCredentials: true});
                if (response.data.success) {
                    setFlowMeters(response.data.payload);
                } else {
                    toast.error('Not got data from database');
                }
                
            } catch (err) {
                console.log(err.response);
            }
        };
        fetchFlowMeters();
    }, []);

    useEffect(() => {
        const handlePlaces = () => {
            const newplaces = [...new Set(flowMeters.map(item => item.location_id.place))] 
            return newplaces.map((name, index) => ({id: index+1, name: name}));
            
        }
        if (flowMeters.length > 0) {
            setPlaces(handlePlaces());
        }
    }, [flowMeters])

    useEffect(() => {
        const filterPlaces = () => {
            const newthoroughfare = flowMeters.filter(flowmeter => flowmeter.location_id.place === selectedPlace).map((fl, index) => ({id: index+1, name: fl.location_id.thoroughfare}))
            return newthoroughfare.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setThoroughfares(filterPlaces())
        }
    }, [selectedPlace])

    useEffect(() => {
        const filterPlacesAndThoroughfares = () => {
            const newTypeLines = flowMeters
                                    .filter(flowmeter => flowmeter.location_id.place === selectedPlace && flowmeter.location_id.thoroughfare === selectedThoroughfare)
                                    .map((fl, index) => ({id: index+1, name: fl.location_id.type_line}))
            
            return newTypeLines.reduce((acc, current) => {
                if (!acc.some(item => item.name === current.name)) {
                    acc.push(current);
                }
                return acc
            }, [])
        }
        if (flowMeters.length > 0) {
            setTypeLines(filterPlacesAndThoroughfares())
        }
    }, [selectedThoroughfare])


    return (
        <div className='flow-meter-choice-container'>
            <h2 className='flow-meter-choice-title'>Flow Meter</h2>
            <div className='flow-meter-choice-card'>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Place:
                    </label>
                    <SelectPlace
                        places={places}
                        selectedPlace={selectedPlace}
                        setSelectedPlace={setSelectedPlace}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Section:
                    </label>
                    <SelectThoroughfare
                        thoroughfares={thoroughfares}
                        selectedThoroughfare={selectedThoroughfare}
                        setSelectedThoroughfare={setSelectedThoroughfare}
                    />
                </div>
                <div className="choice-input-group">
                    <label
                        htmlFor=''
                        className='bold-label'
                    >
                        Type line:
                    </label>
                    <SelectTypeLines
                        LocationTypeLines={typeLines}
                        selectedlocationTypeLine={selectedTypeLine}
                        setSelectedLocationTypeLine={setSelectedTypeLine}
                    />
                </div>
                <button
                    className='flow-meter-choice-button'
                    onClick={handleView}>View &nbsp; <FaMagnifyingGlass /></button>
            </div>
            <BackButton navigateTo='/manage-database'/>
        </div>
    );
        
};

export default FlowMeterChoice;